import { ActionIcon, Flex, Table, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconUserSearch } from '@tabler/icons-react';
import UserListModal from './userListModal';
import useGetShipmentHistory from '../hooks/useGetShipmentHistory';
import { useSearchParams } from 'react-router-dom';
import { handleChangeLocaleTime } from '../../../../../../shared/utils/time';
import { useState } from 'react';

export default function ServiceChannelInfo() {
  const [opened, { open, close }] = useDisclosure(false);
  const [searchParams] = useSearchParams();
  const [companyId, setCompanyId] = useState<number | null>(null);
  const [serviceChannel, setServiceChannel] = useState('');

  const mac = searchParams.get('mac') || '';

  const { data } = useGetShipmentHistory({ mac });

  const handleOpenModal = (companyId: number, serviceChannel: string) => {
    setCompanyId(companyId);
    setServiceChannel(serviceChannel.toLowerCase());
    open();
  };
  return (
    <div>
      <Text fw={600} mb="xs">
        서비스 채널
      </Text>
      <Table>
        <Table.Thead bg="gray.0">
          <Table.Tr>
            <Table.Th fw={400}>서비스 채널</Table.Th>
            <Table.Th fw={400}>거래처명</Table.Th>
            <Table.Th fw={400}>서비스 사용 여부</Table.Th>
            <Table.Th fw={400}>등록 일자</Table.Th>
            <Table.Th fw={400}>유저 상세</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data && data.length > 0 ? (
            data.map((item) => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.channel}</Table.Td>
                <Table.Td>{item.customerName}</Table.Td>
                <Table.Td>
                  {item.registrationStatus.toUpperCase() === 'UNREGISTERED'
                    ? '미사용'
                    : item.registrationStatus.toUpperCase() === 'PENDING'
                      ? '승인 대기'
                      : '사용'}
                </Table.Td>
                <Table.Td>{handleChangeLocaleTime(item.regDt)?.substring(0, 19)}</Table.Td>
                <Table.Td>
                  <Flex justify="center" align="center" height="100%">
                    <ActionIcon
                      size="sm"
                      variant="outline"
                      radius="xl"
                      onClick={() => handleOpenModal(item.toCompanyId, item.channel)}
                    >
                      <IconUserSearch size={16} />
                    </ActionIcon>
                  </Flex>
                </Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={5}>
                <Text align="center" size="sm">
                  데이터가 없습니다.
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
      {opened && companyId !== null && (
        <UserListModal opened={opened} onClose={close} companyId={companyId} serviceChannel={serviceChannel} />
      )}
    </div>
  );
}
